import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const TableFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 4C4.75544 4 3.80161 4.39509 3.09835 5.09835C2.39509 5.80161 2 6.75544 2 7.75V15.25C2 16.2446 2.39509 17.1984 3.09835 17.9017C3.80161 18.6049 4.75544 19 5.75 19H18.25C19.2446 19 20.1984 18.6049 20.9017 17.9017C21.6049 17.1984 22 16.2446 22 15.25V7.75C22 6.75544 21.6049 5.80161 20.9017 5.09835C20.1984 4.39509 19.2446 4 18.25 4H5.75ZM4.5 15.25V14H10.75V16.5H5.75C5.41848 16.5 5.10054 16.3683 4.86612 16.1339C4.6317 15.8995 4.5 15.5815 4.5 15.25ZM13.25 16.5H18.25C18.5815 16.5 18.8995 16.3683 19.1339 16.1339C19.3683 15.8995 19.5 15.5815 19.5 15.25V14H13.25V16.5ZM13.25 11.5H19.5V9H13.25V11.5ZM10.75 9H4.5V11.5H10.75V9Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TableFilledIcon.displayName = 'TableFilledIcon';
